import { getEntryStartTime, getEntryEndTime } from '@/utils/dateTimeUtils';
angular.module('leanlaw').directive('entryList', ['userService', function (userService) {
  return {
    restrict: 'A',
    scope: {
      entries: '=ngModel',
      entry: '=?',
      showFullDescriptions: '=?',
      shortDescriptions: '=?',
      areTimesVisible: '=?',
      printing: '=?',
      loading: '=?',
      activeEntry: '=',
      selectEntry: '=',
      page: '=?',
      pageChanged: '=?',
      summary: '=',
      showAllEntries: '=?',
      sort: '=?',
      reverse: '=?'
    },
    template: require('./views/entryList.html'),
    link($scope) {
      userService.me().then(me => {
        $scope.me = me;
      });

      // Returns array of new entries
      $scope.getNewEntries = function () {
        if (!$scope.entries) return [];
        return $scope.entries.filter(e => e.isNewEntry);
      };

      // Filters and removes new entries
      $scope.getExistingEntries = function () {
        return ($scope.entries || []).filter(e => !e.isNewEntry);
      };

      // Sum of hours
      $scope.getTotalHours = function getTotalHours() {
        if (!$scope.entries) return 0;
        const hours = $scope.entries.reduce((sum, e) => sum + e.hours, 0.0);
        return hours;
      };

      // Sum of amount
      $scope.getTotalAmount = function getTotalAmount() {
        if (!$scope.entries) return 0;
        return $scope.entries.reduce((sum, e) => sum + e.amount, 0.0);
      };

      // Story #41530: Get formatted start time using shared utility
      $scope.getFormattedStartTime = function (entry) {
        var useDateHandling = $scope.me && $scope.me.features && $scope.me.features.dateHandling;
        return getEntryStartTime(entry, useDateHandling);
      };

      // Story #41530: Get formatted end time using shared utility
      $scope.getFormattedEndTime = function (entry) {
        var useDateHandling = $scope.me && $scope.me.features && $scope.me.features.dateHandling;
        return getEntryEndTime(entry, useDateHandling);
      };
    }
  };
}]);